import Fingerprint2 from "fingerprintjs2";

export const makeFingerprint = () => {
  return Fingerprint2.getPromise().then(components => {
    const values = components.map(c => c.value);

    return Fingerprint2.x64hash128(values.join(""), 31);
  });
};
